<template>
  <div class="bg-white rounded-[12px] p-4 shadow-sm w-[431px] h-[248px]" style="border: 1px solid #EEEEEE;">
    <div class="flex items-center gap-4">
      <div class="w-[180px] h-[180px] rounded-full overflow-hidden border border-grayLight flex items-center justify-center">
        <img 
          v-if="avatar" 
          :src="avatar" 
          alt="avatar" 
          class="w-full h-full object-cover" 
        />
        <UserAvatar 
          v-else 
          :fullName="name" 
          class="w-full h-full text-[24px]" 
        />
      </div>

      <div class="flex-1 min-w-0">
        <div class="flex items-center mb-1">
          <img v-for="(b, i) in miniBadges" :key="i" :src="b" alt="badge" class="w-full h-full" />
        </div>

        <div class="flex items-center flex-wrap gap-1">
          <p class="text-[20px] font-medium text-[#4C4D4F] truncate">{{ name }}</p>
          <span class="text-[16px] text-bodyText text-[#667085]">{{ role }}</span>
          <span v-if="title" class="text-[10px] px-2 py-0.5 rounded-[6px] border border-grayLight text-bodyText">{{ title }}</span>
        </div>

        <div class="mt-2 flex flex-col gap-2 text-[12px] text-bodyText">
          <div class="flex items-center gap-2">
            <img :src="require('@/assets/achievements/chart.svg')" alt="milestones" class="w-4 h-4" />
            <span><span class="font-medium">Milestones Achieved:</span> {{ milestones }}</span>
          </div>
          <div class="flex items-center gap-2">
            <img :src="require('@/assets/achievements/dark-trophy.svg')" alt="badges" class="w-4 h-4" />
            <span><span class="font-medium">Total Badges Collected:</span> {{ badgesCollected }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from "../auth/UserAvatar.vue";

export default {
  name: 'UserAchievementsCard',
  components: {
    UserAvatar,
  },
  props: {
    name: { type: String, default: 'User' },
    role: { type: String, default: 'Talent' },
    title: { type: String, default: '' },
    avatar: { type: String, default: '' },
    milestones: { type: Number, default: 0 },
    badgesCollected: { type: Number, default: 0 },
  },
  computed: {
    awardIcon() {
      return require('@/assets/award.svg');
    },
    miniBadges() {
      const a = require('@/assets/achievements/gold-medal.svg');
      const b = require('@/assets/achievements/medal-purple.svg');
      const c = require('@/assets/achievements/bronze-medal.svg');
      return [a, b, c];
    },
  },
};
</script>

<style scoped>
</style>
